import defaultConfig from './default';

let initialized = false;

let config = defaultConfig;
export const getConfigItem = (key) => {
    if (!initialized) {
        throw new Error('Config not initialized');
    }
    if(config[key] === undefined){
        throw new Error(`Config key ${key} not found`);
    }
    return config[key];
}

export const initConfig = ({
                               YAWN_CERTAINTY_THRESHOLD,
                               YAWN_TIREDNESS_TIME_THRESHOLD,
                               EYE_CLOSED_CERTAINTY_THRESHOLD,
                               EYE_CLOSED_ASLEEP_TIME_THRESHOLD,
                               EYE_BLINKED_CERTAINTY_THRESHOLD,
                               YAW_ANGLE_ALERT_THRESHOLD,
                               PITCH_ANGLE_MIN_ALERT_THRESHOLD,
                               PITCH_ANGLE_MAX_ALERT_THRESHOLD,
                               YAW_ANGLE_MIN_ALERT_THRESHOLD,
                               YAW_ANGLE_MAX_ALERT_THRESHOLD,
                               PITCH_ANGLE_MIN_EMOTION_FILTER_THRESHOLD,
                               PITCH_ANGLE_MAX_EMOTION_FILTER_THRESHOLD,
                               YAW_ANGLE_MIN_EMOTION_FILTER_THRESHOLD,
                               YAW_ANGLE_MAX_EMOTION_FILTER_THRESHOLD,
                               ROLL_ANGLE_MIN_EMOTION_FILTER_THRESHOLD,
                               ROLL_ANGLE_MAX_EMOTION_FILTER_THRESHOLD,
                               FILTER_BOX_SIZE,
                               FILTER_BOX_SIZE_ACTIVE,
                               HAND_POINTS_ON_FACE_THRESHOLD,

                               DETECTION_SCORE_FILTER_ACTIVE,
                               DETECTION_SCORE_THRESHOLD,
                               MASK_MODEL_ACTIVE,
                               MASK_ON_CERTAINTY_THRESHOLD,
                               HEAD_ANGLE_EMOTION_FILTER_ACTIVE,
                               LIGHT_FILTER_ACTIVE,
                               LIGHT_FILTER_THRESHOLD,
                               HAND_FILTER_ACTIVE,
                           }) => {
    config = {
        YAWN_CERTAINTY_THRESHOLD,
        YAWN_TIREDNESS_TIME_THRESHOLD,
        EYE_CLOSED_CERTAINTY_THRESHOLD,
        EYE_CLOSED_ASLEEP_TIME_THRESHOLD,
        EYE_BLINKED_CERTAINTY_THRESHOLD,
        YAW_ANGLE_ALERT_THRESHOLD,
        PITCH_ANGLE_MIN_ALERT_THRESHOLD,
        PITCH_ANGLE_MAX_ALERT_THRESHOLD,
        YAW_ANGLE_MIN_ALERT_THRESHOLD,
        YAW_ANGLE_MAX_ALERT_THRESHOLD,
        PITCH_ANGLE_MIN_EMOTION_FILTER_THRESHOLD,
        PITCH_ANGLE_MAX_EMOTION_FILTER_THRESHOLD,
        YAW_ANGLE_MIN_EMOTION_FILTER_THRESHOLD,
        YAW_ANGLE_MAX_EMOTION_FILTER_THRESHOLD,
        ROLL_ANGLE_MIN_EMOTION_FILTER_THRESHOLD,
        ROLL_ANGLE_MAX_EMOTION_FILTER_THRESHOLD,
        HAND_POINTS_ON_FACE_THRESHOLD,
        FILTER_BOX_SIZE,
        DETECTION_SCORE_FILTER_ACTIVE,
        DETECTION_SCORE_THRESHOLD,
        MASK_MODEL_ACTIVE,
        MASK_ON_CERTAINTY_THRESHOLD,
        HEAD_ANGLE_EMOTION_FILTER_ACTIVE,
        LIGHT_FILTER_ACTIVE,
        LIGHT_FILTER_THRESHOLD,
        HAND_FILTER_ACTIVE,
        FILTER_BOX_SIZE_ACTIVE
    }

    initialized = true;

}

export const setConfigItem = (key, value) => {
    if (!initialized) {
        throw new Error('Config not initialized');
    }
    if(config[key] === undefined){
        throw new Error(`Config key ${key} not found`);
    }
    config[key] = value;
}
